/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'

export default {
  /**
   * getBillList
   * @description 结算清单列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getBillList(data) {
    return request.post('/bill/list', data)
  },
  /**
   * saveBill
   * @description 保存结算清单
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveBill(data) {
    return request.post('/bill/store', data)
  },
  /**
   * getBillInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getBillInfo(id) {
    let data = {id:id}
    return request.post('/bill/get_info', data)
  },
  /**
   * deleteBill
   * @description 删除结算清单
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteBill(id) {
    let data = {id:id}
    return request.post('/bill/delete', data)
  },
  /**
   * @description 获取分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getBillCategoryList() {
    return request.get('/bill/category_list')
  },
}